module.exports = __webpack_public_path__ + "static/servicii-management-proiect-large.faecd8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/servicii/servicii-management-proiect-large.jpg
// module id = 473
// module chunks = 239733815803947